/**
 * Created by Lisbeth on 07.02.2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Input from './Input.jsx';
import ResultsList from './ResultsList.jsx';
import '../styles/App.scss';

export default class Autocomplete extends Component {

    static propTypes = {
        defaultResults: PropTypes.array,
        id: PropTypes.any.isRequired,
        maxCount: PropTypes.number,
        onDelete: PropTypes.func,
        onInput: PropTypes.func,
        onSelect: PropTypes.func,
        placeholder: PropTypes.string,
        repeatOptions: PropTypes.bool,
        showResultsList: PropTypes.bool
    };

    static defaultProps = {
        defaultResults: [],
        maxCount: 5,
        onDelete: null,
        onInput: null,
        onSelect: null,
        placeholder: '',
        repeatOptions: false,
        showResultsList: true
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: this.props.defaultResults
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    shouldComponentUpdate() {
        return true;
    }

    handleSelect(selected) {
        let selectedOptions = this.state.selectedOptions.slice();
        selectedOptions.push(selected);
        this.setState({
            selectedOptions: selectedOptions
        });
        if (this.props.onSelect) {
            this.props.onSelect(selected)
        }
    }

    handleDelete(deleted) {
        this.setState({
            selectedOptions: this._remove(this.state.selectedOptions, deleted)
        });
        if (this.props.onDelete) {
            this.props.onDelete(deleted)
        }
    }

    _remove(array, element) {
        let results = array.slice();
        let elementIndex = array.indexOf(element);
        if (elementIndex !== -1) {
            results.splice(elementIndex, 1);
        }
        return results;
    };

    render() {
        return (
            <div className="Autocomplete">
                <Input
                    id={this.props.id}
                    maxCount={this.props.maxCount}
                    onInput={this.props.onInput}
                    onSelect={(selected) => this.handleSelect(selected)}
                    optionsToExclude={this.state.selectedOptions}
                    placeholder={this.props.placeholder}
                    repeatOptions={this.props.repeatOptions}
                />
                {(this.props.showResultsList && this.state.selectedOptions.length > 0) ?
                    <ResultsList
                        defaultResults={this.state.selectedOptions}
                        onDelete={(deleted) => this.handleDelete(deleted)}
                    />
                    : null
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Autocomplete.jsx